<template>
  <div class="equipment_management">

    <div :class='["information_box","light_border","list"]'
         :style="[{width:'690px'},{height:'calc(100% - 40px)'},{'padding':'20px'},{'box-sizing':'border-box'}]">
      <div class="border_top_left"></div>
      <div class="border_top_right"></div>
      <div class="border_bottom_left"></div>
      <div class="border_bottom_right"></div>
      <div class="h_light_right" :style="{top:'0'}"></div>
      <div class="information_content">
        <div id="table_box">
          <div class="search">
            <div class="search_box">
              <div v-for="item in search" :class='["search_options_box"]'>
                <span style="width: 100px;">{{item.title}}</span>
                <el-select class="select" v-model="selectValue" placeholder="请选择项目">
                  <el-option v-for="item2 in item.options" :label="item2.label" :value="item2.value" :key="item2.value"></el-option>
                </el-select>
              </div>
              <div class="search_btn_box">
                <button :class='["search_btn","green","icon_btn","clearborder"]'><span class="el-icon-search"></span>搜索</button>
              </div>
            </div>
          </div>
          <div class="table_content">
            <table>
              <thead>
              <tr>
                <th>设备识别码</th>
                <th>灯杆编号</th>
                <th>位置</th>
                <th>状态</th>
<!--                <th>操作</th>-->
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in table_data">
                <td>{{item.device_serial}}</td>
                <td>{{item.lamp_post}}</td>
                <td>{{item.address}}</td>
                <td v-if="item.status=='0'">在线</td>
                <td v-else="item.status=='1'">离线</td>
<!--                <td class="table_btn_box">-->
<!--                  <button class="table_btn" style=" margin-right: 10px;">编辑</button>-->
<!--                  <button class="table_btn">删除</button>-->
<!--                </td>-->
              </tr>
              </tbody>
            </table>
          </div>
          <div class="table_paging">
            <p>当前记录<span>1</span>到<span>{{table_data.length}}</span>条，共<span>{{table_data.length}}</span>条记录
              <button
                v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
              <button
                v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
              第<span>1</span>/<span>1</span>页
              <button
                v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
              <button
                v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div id="details" :class='["information_box","light_border","weather_box"]'
         :style="[{width:'500px'},{height:'380px'}]">
      <div class="border_top_left"></div>
      <div class="border_top_right"></div>
      <div class="border_bottom_left"></div>
      <div class="border_bottom_right"></div>
      <div class="h_light_right" :style="{top:'95px'}"></div>
      <div class="information_content">
        <div class="details">
          <h1>
            <span id="site">报警器&nbsp;<span id="alertor">D12456141</span></span>
            <button @click="close()">X</button>
          </h1>
          <p>近期警情</p>
          <ul>
            <li>
              <p>消息id：<span>1111111111</span></p>
              <p>报警时间：<span>2019-07-30 15:30:02</span></p>
            </li>
            <li>
              <p>消息id：<span>1111111111</span></p>
              <p>报警时间：<span>2019-07-30 15:30:02</span></p>
            </li>
            <li>
              <p>消息id：<span>1111111111</span></p>
              <p>报警时间：<span>2019-07-30 15:30:02</span></p>
            </li>
            <li>
              <p>消息id：<span>1111111111</span></p>
              <p>报警时间：<span>2019-07-30 15:30:02</span></p>
            </li>
            <li>
              <p>消息id：<span>1111111111</span></p>
              <p>报警时间：<span>2019-07-30 15:30:02</span></p>
            </li>
            <li>
              <p>消息id：<span>1111111111</span></p>
              <p>报警时间：<span>2019-07-30 15:30:02</span></p>
            </li>
            <li>
              <p>消息id：<span>1111111111</span></p>
              <p>报警时间：<span>2019-07-30 15:30:02</span></p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div id="map"></div>

  </div>
</template>

<script>
  export default {
    name: "equipment_management",
    computed:{
      mapstyle(){
        return this.$store.state.mapstyle
      }
    },
    data() {
      return {
        search: [
          {
            title: '选择项目',
            options: [],
          },
        ],
        projectList:[],
        selectValue:'17e3b71e-b460-498e-b0ef-657d20bd6549',
        table_data: [],
        point: [

          {
            "id": "001",
            "lng": 114.614072,
            "lat": 38.125895,
            "number": "3",
            "site": "石家庄国际会展中心",
          },
          {
            "id": "002",
            "lng": 115.566321,
            "lat": 38.24126,
            //"number": "3",
            "site": "安平县吉祥公园",
          },
          {
            "id": "003",
            "lng": 115.534317,
            "lat": 38.22763,
            //"number": "3",
            "site": "安平县汉王酒店",
          },
          {
            "id": "004",
            "lng": 115.523508,
            "lat": 38.239905,
            //"number": "3",
            "site": "安平县为民街道",
          },
          {
            "id": "005",
            "lng": 115.523477,
            "lat": 38.240114,
            //"number": "3",
            "site": "安平县为民街道",
          },
        ],
      }


    },
    mounted() {
      this.getProjectList();
      $("#details").hide();
      fetch("/api/v1/alarm/DeviceDataList", {
        method: 'post',
        body: JSON.stringify({
          "project_id": "f899dfb4a9094ac48fbb27b64021d5e1",
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        .then(data => {
          this.table_data = data.data;
          this.drawMap();
          console.log(this.table_data)
        })
        .catch((error) => {
          console.log(error);
        });
    },
    methods: {
      InitLeftMenu: function () {
        this.$emit('getMessage', '6', '0');
      },

      //获取项目列表
      getProjectList:function(){
        fetch("/api/v1/project/list", {
          method: 'post',
          body: JSON.stringify({

          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "项目数据获取成功";
              this.projectList = data.data;
              let options = this.search[0].options;
              for (let i=0;i<this.projectList.length;i++){
                let projectObj = {};
                projectObj.label = this.projectList[i].name;
                projectObj.value = this.projectList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },

      drawMap() {
        let map = new BMap.Map('map');
        let point = new BMap.Point(115.534317,38.22763);// 创建点坐标
        map.centerAndZoom(point, 13);// 初始化地图，设置中心点坐标和地图级别
        map.enableScrollWheelZoom();//启用滚轮放大缩小，默认禁用。
        let points = this.point;//标记点数据
        let styleJson = this.mapstyle;
        //map.setMapStyleV2({styleJson: styleJson});//引入地图样式
        function addMarker(points) {
          //循环建立标注点
          for (var i = 0, pointsLen = points.length; i < pointsLen; i++) {
            var point = new BMap.Point(points[i].lng, points[i].lat); //将标注点转化成地图上的点
            var animation = false; // 动画状态
            //添加监听事件
            map.enableScrollWheelZoom();
            (function () {
              var $id = points[i].id;
              var myicon = new BMap.Icon("/static/img/icon/baojing.png", new BMap.Size(64, 74), {
                // 图标中央下端的尖角位置。
                anchor: new BMap.Size(32, 74),
              });
              var marker = new BMap.Marker(point, {icon: myicon}, point[i]);
              map.addOverlay(marker);
              marker.addEventListener("click", function attribute() {
                // $.ajax({
                //   type: "POST",
                //   url: "/",
                //   contentType: 'application/x-www-form-urlencoded;charset=utf-8',
                //   data: {$id},
                //   dataType: "json",
                //   success: function (data) {
                //     $("#details").fadeIn(200);
                //     $("#alertor").text($id)
                //   },
                //   error: function (e) {
                //     console.log(e);
                //   }
                // })
                // $("#details").fadeIn(200);
                $("#alertor").text($id);
              });

            })();

          }
        }

        addMarker(points);
      },
      close() {
        $("#details").fadeOut(200);
      },
    },
    created() {
      this.InitLeftMenu()
    }
  }
</script>

<style scoped>
  .equipment_management {
    width: 100%;
    height: 100%;
    position: relative;
  }

  #map {
    width: 100%;
    height: 100%;
    background: #FFFFFF;
  }

  #table_box {

  }

  .table_paging {
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #094b8e;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .search {
    width: 100%;
    height: 48px;
    padding: 0;
  }

  .search_box {
    width: 100%;
    height: 48px;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }

  .search_options_box {
    width: 240px;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #a2b9d1;
    color: #a2b9d1;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 22px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  #table {

  }

  .table_content {
    width: 100%;
    height: calc(100% - 100px);
    padding: 20px 0;
    box-sizing: border-box;
  }

  #table_box {
    width: 100%;
    height: 100%;
  }

  .table_content > table {
    width: 100%;
    border: 1px solid #094b8e;
    background-color: #16518d;
  }

  .table_content > table tr th {
    background-color: #0e345b;
  }

  .table_content > table tr td {
    /*background-color: #16518d;*/
  }

  .table_content > table tr td input {
    width: 16px;
    height: 16px;

  }

  .table_content > table tr:nth-child(2n) {
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 60px
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }

  .table_btn {
    color: #95bee5;
    background: transparent;
    border: 1px solid #95bee5;
    outline: transparent;
    padding: 5px 20px;
    border-radius: 6px;
  }

  .list {
    position: absolute;
    left: 20px;
    top: 0px;
    z-index: 99;
  }

  #details {
    position: absolute;
    right: 20px;
    top: 0;
    z-index: 999;
  }

  .details {
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  .details > h1 {
    width: 100%;
    height: 30px;
    line-height: 30px;
    position: relative;
    display: flex;
    align-items: center;
  }

  .details > h1 > span:nth-child(1) {
    font-size: 20px;
    line-height: 30px;
    color: #00f0ff;
  }

  .details > h1 > button {
    color: #00f0ff;
    background: transparent;
    border: none;
    font-size: 24px;
    position: absolute;
    right: 0;
    top: 0;
    font-family: "方正兰亭中黑_GBK";
    outline: none;
  }

  .details > p {
    color: #95bee5;
    margin-bottom: 0px;
  }

  .details > ul {
    overflow-y: auto;
    width: 100%;
    height: calc(100% - 58px);
  }

  .details > ul > li {
    width: 100%;
    border-bottom: 1px solid #556e88;
    height: 70px;
    padding: 10px 0;
    box-sizing: border-box;
  }

  .details > ul > li:last-child {
    border: none;
  }

  .details > ul > li > p {
    height: 25px;
    line-height: 25px;
    margin-bottom: 0;
    color: #FFFFFF;
  }

  .details > ul > li > p > span {
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/7_alarm/equipment_management.vue